// If you need to support IE11 uncomment the imports below
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/es/integration/react";
import { persistStore } from "redux-persist";
import { Provider } from "react-redux";
import "../src/index.css";
import { store } from "./app/store";
import App from "./App";
import { ThemeProvider } from "./theme/ThemeContext";
import MuiThemeBridge from "./theme/MuiThemeBridge";

// MSAL imports
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "G-DBG72216EG",
};

TagManager.initialize(tagManagerArgs);

export const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        {/* Outermost app-level provider so every route (including the
            no-chrome standalone pages) can read the theme. */}
        <ThemeProvider>
          <MuiThemeBridge>
            <App pca={msalInstance} />
          </MuiThemeBridge>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </Router>
);
